export const defaultVars = {
  shifter_name: 'friend',
  shifter_age: null as number | null,
};
